export const API = "https://online-shop-master.herokuapp.com/api/"
